var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.597,
    height: 76.595,
    viewBox: "0 0 76.597 76.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4969",
    width: 76.597,
    height: 76.595,
    fill: "#1fba9c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "korl\\xE1tlan_karakter",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10889",
    d: "M68.621,65.83a1.1,1.1,0,0,1-.4-.07l-13.9-4.936a32.9,32.9,0,1,1,10.5-10.495l4.925,13.9a1.184,1.184,0,0,1-.286,1.249,1.156,1.156,0,0,1-.842.353M36.908,2.392A30.52,30.52,0,1,0,53.522,58.5a1.26,1.26,0,0,1,1.055-.127l12.078,4.294L62.366,50.572a1.152,1.152,0,0,1,.132-1.041A30.516,30.516,0,0,0,36.908,2.392",
    transform: "translate(6.779 -0.001)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10890",
    d: "M43.066,50.781a25.622,25.622,0,0,1-28.941.658,1.23,1.23,0,0,0-1.049-.132l-9.9,3.514,3.514-9.9a1.205,1.205,0,0,0-.127-1.055,25.571,25.571,0,0,1,.658-28.941c-.005-.21-.038-.415-.038-.62,0-1.133.07-2.241.175-3.342a27.968,27.968,0,0,0-3.118,33.7L.07,56.386a1.2,1.2,0,0,0,1.127,1.6,1.2,1.2,0,0,0,.4-.07l11.722-4.156a27.986,27.986,0,0,0,33.7-3.129c-1.106.105-2.214.175-3.336.175-.21,0-.41-.027-.62-.027",
    transform: "translate(0 18.609)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10891",
    d: "M17.164,14.464a3.59,3.59,0,1,1-3.587-3.593,3.586,3.586,0,0,1,3.587,3.593",
    transform: "translate(16.945 18.449)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10892",
    d: "M22.045,14.464a3.59,3.59,0,1,1-3.587-3.593,3.582,3.582,0,0,1,3.587,3.593",
    transform: "translate(25.229 18.449)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10893",
    d: "M26.931,14.464a3.593,3.593,0,1,1-3.593-3.593,3.587,3.587,0,0,1,3.593,3.593",
    transform: "translate(33.513 18.449)",
    fill: "#1fba9c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.3b848e36524cef88a7223eb945a45c8c.svg";
export { ForwardRef as ReactComponent };